import {
    GETDELETEMANAGEMENTLISTADMIN_SUCCESS,
    GETDELETEMANAGEMENTLISTADMIN_FAILED,
    RESET_GETDELETEMANAGEMENTLISTADMIN,
    LOADING_GETDELETEMANAGEMENTLISTADMIN,
    NETWORK_ERROR_GETDELETEMANAGEMENTLISTADMIN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETDELETEMANAGEMENTLISTADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETDELETEMANAGEMENTLISTADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETDELETEMANAGEMENTLISTADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETDELETEMANAGEMENTLISTADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETDELETEMANAGEMENTLISTADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
